/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatTurn
 */
export interface ChatTurn {
    /**
     * 
     * @type {string}
     * @memberof ChatTurn
     */
    fromUser: string;
    /**
     * 
     * @type {string}
     * @memberof ChatTurn
     */
    fromBot?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatTurn
     */
    readonly combinedCharacterCount: number;
}

/**
 * Check if a given object implements the ChatTurn interface.
 */
export function instanceOfChatTurn(value: object): value is ChatTurn {
    if (!('fromUser' in value) || value['fromUser'] === undefined) return false;
    if (!('combinedCharacterCount' in value) || value['combinedCharacterCount'] === undefined) return false;
    return true;
}

export function ChatTurnFromJSON(json: any): ChatTurn {
    return ChatTurnFromJSONTyped(json, false);
}

export function ChatTurnFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatTurn {
    if (json == null) {
        return json;
    }
    return {
        
        'fromUser': json['fromUser'],
        'fromBot': json['fromBot'] == null ? undefined : json['fromBot'],
        'combinedCharacterCount': json['combinedCharacterCount'],
    };
}

export function ChatTurnToJSON(json: any): ChatTurn {
    return ChatTurnToJSONTyped(json, false);
}

export function ChatTurnToJSONTyped(value?: Omit<ChatTurn, 'combinedCharacterCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromUser': value['fromUser'],
        'fromBot': value['fromBot'],
    };
}

